//export const api = 'https://localhost:7200/api';
export const api = 'https://bass-gremlin-api.azurewebsites.net/api';
//export const api = 'https://bassgremlin.com/api';
